const {Component} = require("react");
const PropTypes = require("prop-types");
const env = require("app/services/env");
const RestrictedInput = require("app/components/fields/RestrictedInput");
const MobileOption = require('app/components/products/configuration-mobile/MobileOption')
const Trans              = require('app/components/trans/Trans')
const { numberFormat } = require('app/util/formaters')

class RibbonSelector extends Component {

	static get propTypes() {
		return {
			option: PropTypes.any,
			texts: PropTypes.any,
			onChange: PropTypes.func
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			option: props.option || "none",
			texts: props.texts && (props.texts instanceof Array) ? props.texts : [],
			optionsOpen: false,
          ribbonTitle: translate('Intet bånd valgt')
		};

		// Transform ribbons to a more accessible format
		this.ribbons = {};

		env.get("checkout.ribbons", []).forEach(ribbon => {
			this.ribbons[ribbon.id] = ribbon;
		});
	}

	getRibbonPlaceholder(index) {
		const ribbonIndex = Math.round((index + 1) / 2);
		const lineIndex = (index + 1) % 2 === 0 ? 2 : 1;

        return translate('Tekst på bånd :ribbonIndex, linje :lineIndex', {ribbonIndex: ribbonIndex, lineIndex: lineIndex});
	}

	normalizeMessages(messages, length) {
		if (messages.length > length) {
			return messages.slice(0, length);
		}

		if (messages.length < length) {
			for (let i = messages.length; i < length; i++) {
				messages.push("");
			}
		}

		return messages;
	}

	get value() {
		if (this.state.option === "none") {
			return;
		}

		return {
			id: this.state.option,
			messages: this.state.texts
		};
	}

	get options() {
		let options = [];

        let zeroPrice = numberFormat(0, true);

		// Placeholder
		options.push({
			title: translate('Intet bånd (:price)', {price: zeroPrice}),
			value: "none"
		});

		// Add the rest of the ribbons
		Object.keys(this.ribbons).forEach(ribbonId => {
			options.push({
				title: this.ribbons[ribbonId].title,
				value: ribbonId
			});
		});

		return options;
	}

	get current() {
		if (this.state.option === "none") {
			return;
		}

		return this.ribbons[this.state.option];
	}

	get editIcon () {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'>
        <g transform='translate(-1160.001 -187)'>
          <path d='M618,184.874V189h-7.5v-7.5h4.125l1.5-1.5h-6A1.128,1.128,0,0,0,609,181.124v8.25a1.128,1.128,0,0,0,1.125,1.125h8.25a1.128,1.128,0,0,0,1.125-1.125v-6Z' transform='translate(551.001 8.501)' fill='#444' />
          <path d='M620.125,178,613,185.124V187h1.875L622,179.874A1.771,1.771,0,0,0,620.125,178Z' transform='translate(550.001 9.001)' fill='#444' />
        </g>
      </svg>
    )
  }

	reset() {
		this.selectElement.value = "none";

		this.setState({
			option: "none",
			texts: [],
			optionsOpen: false,
			ribbonTitle: translate('Intet bånd valgt')
		});
	}

	onChange() {
		if (typeof this.props.onChange === "function") {
			return this.props.onChange(this.value);
		}
	}

	_onOptionChange = (e) => {
		const ribbonId = e.target.value;
		const placeholders = ribbonId === "none" ? 0 : this.ribbons[ribbonId].ends * 2;
		const ribbonTitle = ribbonId === "none" ? translate('Intet bånd valgt') : translate('Ret båndtype');

		this.setState({
			option: ribbonId,
			texts: this.normalizeMessages(this.state.texts, placeholders),
			ribbonTitle: ribbonTitle
		});

		this.onChange();
	};

	_inputChangeListener = (index) => {
		return (e) => {
			const value = e.target.value;

			this.setState(state => {
				state.texts[index] = value;
				return state;
			});

			this.onChange();
		};
	};

	renderInputs() {
		const placeholders = this.current.ends * 2;
		let inputs = [];
		let text;

		for (let i = 0; i < placeholders; i++) {
			text = this.state.texts[i] || "";

			inputs.push(
				<RestrictedInput maxLength={40} key={i} onInput={this._inputChangeListener(i)} type="text" defaultValue={text}
												 placeholder={this.getRibbonPlaceholder(i)}/>
			);
		}

		return inputs;
	}


	renderInputBody() {
		const current = this.current;

		if (!current || (current.placeholders === 0)) {
			return;
		}

		return (
			<div className="product-configurator-scrollable product-configurator-scrollable--xsmall">
				<div className="text-inputs">{this.renderInputs()}</div>
			</div>
		);
	}

	renderOptionsNew () {
		return this.options.map((ribbon, key) => 
			<MobileOption key={ribbon.value} value={ribbon.value} name='ribbon-selector' text={ribbon.title} defaultChecked={key === 0} onClick={this._onOptionChange} />)
  }

	handleOnClick (e) {
    const val = e.target.value;
	const title = e.target.parentElement.innerText;

    this.setState({ ribbonTitle: title })
  };

	openOptions () {
    this.setState({ optionsOpen: true })
    this.props.editOptions()
  }

  closeOptions () {
    this.setState({ optionsOpen: false })
    this.props.saveOptions()
  }

	render() {
		return (
			<div className='ribbon-widget'>
				<div className="product-configurator-info">
					<div className="product-configurator-info__row">
						<div>
							<span className="product-configurator-info__text"><Trans>Valgt båndtype: </Trans></span>
						</div>
						<div className='product-configurator-info__title product-configurator-info__title--flex cursor-pointer' onClick={() => this.openOptions()}>
              {this.editIcon}
              <span>
								{this.state.ribbonTitle}
              </span>
            </div>
					</div>
				</div>
				<div className="product-configurator-options" style={this.state.optionsOpen ? { display: 'block' } : null}>
					<div className="product-configurator-title">
            <Trans>Vælg båndtype og -tekst</Trans>
          </div>
					<div className="mobile-options">
						<div className="product-configurator-scrollable product-configurator-scrollable--small">
							{this.renderOptionsNew()}
						</div>
						{this.renderInputBody()}
					</div>
					<button className="btn primary" onClick={() => this.closeOptions()}><Trans>Gem</Trans></button>
				</div>
			</div>
		);
	}

}

module.exports = RibbonSelector;
